var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.906 2.994c-3.812 0-6.902 3.075-6.902 6.868s3.09 6.87 6.902 6.87 6.902-3.076 6.902-6.87-3.09-6.868-6.902-6.868M2.004 9.862c0-4.343 3.538-7.864 7.902-7.864S17.81 5.52 17.81 9.862c0 4.344-3.538 7.865-7.903 7.865-4.364 0-7.902-3.521-7.902-7.865",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.793 14.822c.23-.23.605-.23.836 0l6.202 6.172c.23.23.23.602 0 .832a.593.593 0 0 1-.836 0l-6.202-6.172a.586.586 0 0 1 0-.832",
    clipRule: "evenodd"
  })));
};
export default SvgIconSearch;